<!--
 * @Description: 开户中证件有效与失效时间
 * @Date: 2021-11-02 11:16:55
-->
<template>
  <div class="rightLabel">
    <el-form-item :prop="startDtKey" class="rightLabel">
      <span slot="label" class="elLabel">{{ label }}有效期起始日：</span>
      <el-date-picker
        type="date"
        placeholder="例：2000-01-01"
        v-model="value[startDtKey]"
        value-format="yyyy-MM-dd"
        ref="startDt"
        :picker-options="pickerStartOptions"
        :editable="false"
        :clearable="false"
      ></el-date-picker>
    </el-form-item>
    <el-form-item :prop="endDtKey" class="rightLabel">
      <span slot="label" class="elLabel">{{ label }}有效期终止日：</span>
      <div class="flexBox" style="width:310px">
        <el-date-picker
          type="date"
          placeholder="例：2030-12-31"
          v-model="endDt"
          value-format="yyyy-MM-dd"
          ref="endDt"
          :picker-options="pickerEndOptions"
          :editable="false"
          :clearable="false"
          @change="onEndChange"
        ></el-date-picker>
        <el-button style="margin-left:10px" type="primary" @click="onLong">
          长期
        </el-button>
      </div>
    </el-form-item>
  </div>
</template>

<script>
const startDtTailKey = 'StartDt';
const endDtTailKey = 'EndDt';

export default {
  name: 'step1-dt',
  props: {
    label: {
      type: String,
      default: '身份证'
    },
    keyName: {
      type: String,
      default: 'legalPersonCard'
    },
    value: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      startDtKey: this.keyName + startDtTailKey,
      endDtKey: this.keyName + endDtTailKey,
      endDt: '', // 终止时间，设置后会同步到value的字段里
      pickerStartOptions: {
        disabledDate: time => {
          const endValue = this.value[this.endDtKey] || Date.now();
          if (endValue === '长期') {
            return false;
          }
          return (
            time.getTime() >= new Date(endValue).getTime() - 1000 * 60 * 60 * 24
          );
        }
      },
      pickerEndOptions: {
        disabledDate: time => {
          const startValue = this.value[this.startDtKey] || Date.now();
          return time.getTime() <= new Date(startValue).getTime();
        }
      }
    };
  },
  watch: {
    endDt(v) {
      this.$set(this.value, this.endDtKey, v);
    },
    value: {
      immediate: true,
      handler(v) {
        if (v[this.endDtKey] === '长期') {
          this.value[this.endDtKey] = '长期';
          this.$nextTick(() => {
            this.$refs.endDt.$children[0].value = '长期';
          });
        } else {
          this.endDt = this.value[this.endDtKey];
        }
      }
    }
  },
  methods: {
    // 因为中转了endvalue，导致start的disabledDate 【this.value[this.endDtKey]】更新不及时，需要重载（切换月年）才可以
    // 这样处理及时更新了disabledDate中的值【this.value[this.endDtKey]】
    // 在点击长期或者终止时间需要调用此方法
    syncStartDisabledDate() {
      return time => {
        const endValue = this.value[this.endDtKey];
        if (endValue === '长期') {
          return false;
        }
        return (
          time.getTime() >= new Date(endValue).getTime() - 1000 * 60 * 60 * 24
        );
      };
    },
    onEndChange() {
      this.pickerStartOptions.disabledDate = this.syncStartDisabledDate();
    },
    onLong() {
      this.$refs.endDt.$children[0].value = '长期'; // 直接修改了input，会有报错无影响。
      // el没有提供显示方法，值必须是Date，所以使用了endDt与修改ref
      this.$set(this.value, this.endDtKey, '长期');
      this.onEndChange();
    }
  }
};
</script>

<style scoped lang="scss">
.flexBox {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0px;
}
.rightLabel {
  width: 50%;
  >>> .el-form-item__error {
    min-width: 200px;
  }
}
.elLabel {
  color: #333;
  font-size: 14px;
  font-weight: bold;
}
</style>
